import { Box, Select as ChakraSelect } from "@chakra-ui/react";

export default function Select({
  children,
  label,
  value,
  name,
  onChange,
  elevationLevel = 0,
  ...rest
}) {
  return (
    <Box
      pos="relative"
      sx={
        label
          ? {
              span: {
                pointerEvents: "none",
                transition: "color 0.2s",
                top: "50%",
                transform: "translate(-15%,-140%) scale(0.7)",
                left: "1.5rem",
                pos: "absolute",
                fontSize: "14px",
                bg:
                  elevationLevel === 0
                    ? "surface"
                    : `surfaceElevated${elevationLevel}`,
                px: "4px",
                zIndex: 2,
                color: "mediumEmphasis"
              }
            }
          : undefined
      }
      _focusWithin={
        label
          ? {
              span: {
                color: "primary"
              }
            }
          : undefined
      }
      {...rest}
    >
      {label && <span>{label}</span>}
      <ChakraSelect value={value} name={name} onChange={onChange}>
        {children}
      </ChakraSelect>
    </Box>
  );
}
